/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export function TextLabel(props) {
  const { em, data } = props;
  const { parentSize } = em || '';
  const floating = (em && em.floating) || false;
  const groupClass = (floating ? '' : 'row') + ' ' + (em && em.class ? em.class : '');
  const labelClass = floating ? 'label mb-1' : `col-sm-${parentSize === 'full' ? '2' : '12'} col-form-label`;

  return (
    <div className={`form-group ${groupClass}`}>
      <label className={`${labelClass}`}>{em && em.label}</label>
    </div>
  );
}

TextLabel.propTypes = {
  app : PropTypes.any, 
  em : PropTypes.any, 
  data : PropTypes.any
}